{
  "themes.title": "Temas",
  "themes.designSystem": "Sistema de diseño",
  "themes.tokens": "Tokens"
}
